import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private _showSpinner = false;

  constructor() {}

  get showSpinner(): boolean {
    return this._showSpinner;
  }

  /**
   * Shows global spinner
   */
  show(): void {
    this._showSpinner = true;
  }

  /**
   * Hides global spinner
   */
  hide(): void {
    this._showSpinner = false;
  }
}
